module.exports = __webpack_public_path__ + "img/kangmingjian_img10.b575f1ce.jpg";